import React from "react";
import { createRoot } from "react-dom/client";
import Highlights from "../components/Highlights/Highlights";

const highlightRoots = new WeakMap();

const renderHighlights = ($, $context = $(document)) => {
	const blocks = $context.find(".js-highlights-block").toArray();

	if (!blocks.length) return;

	blocks.forEach((element) => {
		const props = {
			...element.dataset,
		};
		let root = highlightRoots.get(element);

		if (!root) {
			root = createRoot(element);
			highlightRoots.set(element, root);
		}

		root.render(<Highlights {...props} />);
	});
};

export default renderHighlights;
